import React from 'react';
import {useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {Statuses} from '../../../utils/hooks';
import {MOBILE_SEARCH_STEPS, SEARCH_RESERVATION_FORM_NAMES} from '../constants';
import {FormTypes} from '../SearchReservationScreen';
import {ButtonStyled, ConfirmButton, MobileAction, SearchForm} from '../styled';
import Input from '../../../components/acommon/FieldInput';

type SearchByBookingReferenceFormProps = {
  onSearch: (
    payload: Pick<FormTypes, SEARCH_RESERVATION_FORM_NAMES.booking_reference>,
  ) => void;
  onChangeMobileStep: (step: MOBILE_SEARCH_STEPS) => () => void;
  setStatus: (status: Statuses) => void;
  isMobileMode: boolean;
  isLoading: boolean;
};
function SearchByBookingReferenceForm({
  onSearch,
  onChangeMobileStep,
  setStatus,
  isLoading,
  isMobileMode,
}: SearchByBookingReferenceFormProps) {
  const {t, i18n} = useTranslation();
  const {
    register,
    handleSubmit,
    trigger,
    formState: {errors, isSubmitted},
  } = useForm<FormTypes>();

  const searchReservationByBookingReference = async (formData: FormTypes) => {
    setStatus(Statuses.loading);
    const payload = {
      [SEARCH_RESERVATION_FORM_NAMES.booking_reference]:
        formData[SEARCH_RESERVATION_FORM_NAMES.booking_reference],
    };
    onSearch(payload);
  };

  React.useEffect(
    function changeTranslationErrorMessages() {
      if (isSubmitted) {
        trigger();
      }
    },
    [isSubmitted, i18n.language, trigger],
  );

  return (
    <SearchForm>
      <Input
        {...register(SEARCH_RESERVATION_FORM_NAMES.booking_reference, {
          required: `${t('required')}`,
        })}
        disabled={isLoading}
        label={t('booking_reference')}
        placeholder={t('enter_reference_code')}
        error={errors[SEARCH_RESERVATION_FORM_NAMES.booking_reference]?.message}
      />
      <ConfirmButton
        onClick={handleSubmit(searchReservationByBookingReference)}
        label={isLoading ? `${t('searching')}...` : t('continue')}
        disabled={isLoading}
      />
      {isMobileMode && (
        <MobileAction>
          <p>{t('or')}</p>

          <div>
            {t('find_my_booking_via')}
            <ButtonStyled
              label={t('checkin_date_and_email')}
              onClick={onChangeMobileStep(MOBILE_SEARCH_STEPS.dateAndEmail)}
              secondary
            />
          </div>
        </MobileAction>
      )}
    </SearchForm>
  );
}

export {SearchByBookingReferenceForm};
